import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiUrl } from "../config/api";
import { adminAuthHeaders } from "../utils/authHeaders";

function AddMazane(){

const [categories,setCategories]=useState([]);

const [selectedCategory,setSelectedCategory]=useState(null);

const [showCategoryModal,setShowCategoryModal]=useState(false);
const [showItemModal,setShowItemModal]=useState(false);

const [title,setTitle]=useState("");



/* ================= دریافت داده ها ================= */

const fetchCategories=async()=>{

try{

const res=await fetch(
apiUrl("/api/categories")
);

const data=await res.json();

setCategories(data);

}catch(e){
toast.error("خطا در دریافت داده ها");
}

};



useEffect(()=>{
fetchCategories();
},[]);




/* ================= ایجاد سربرگ ================= */

const createCategory=async()=>{

if(!title.trim()){
toast.error("نام سربرگ وارد نشده");
return;
}

try{

const res=await fetch(
apiUrl("/api/category"),
{
method:"POST",
headers:adminAuthHeaders({
"Content-Type":"application/json"
}),
body:JSON.stringify({
name:title
})
}
);

const data=await res.json();

if(!res.ok){
toast.error(data.error || "خطا");
return;
}

toast.success("سربرگ ایجاد شد");

setShowCategoryModal(false);
setTitle("");

fetchCategories();

}catch(e){
toast.error("خطای سرور");
}

};




/* ================= ایجاد ساب آیتم ================= */

const createSubItem=async()=>{

if(!selectedCategory){
toast.error("ابتدا یک سربرگ انتخاب کن");
return;
}

if(!title.trim()){
toast.error("نام داده وارد نشده");
return;
}

try{

const res=await fetch(
apiUrl(`/api/category/${selectedCategory}/item`),
{
method:"POST",
headers:adminAuthHeaders({
"Content-Type":"application/json"
}),
body:JSON.stringify({
title:title,
value:"0"
})
}
);

const data=await res.json();

if(!res.ok){
toast.error(data.error || "خطا");
return;
}

toast.success("داده اضافه شد");

setShowItemModal(false);
setTitle("");

fetchCategories();

}catch(e){
toast.error("خطای سرور");
}

};




/* ================= حذف سربرگ ================= */

const deleteCategory=async(id)=>{

const ok=window.confirm("این سربرگ حذف شود؟");

if(!ok) return;

try{

const res=await fetch(
apiUrl(`/api/category/${id}`),
{
method:"DELETE",
headers:adminAuthHeaders()
}
);

const data=await res.json();

if(!res.ok){
toast.error(data.error || "خطا در حذف");
return;
}

toast.success("سربرگ حذف شد");

if(selectedCategory===id){
setSelectedCategory(null);
}

fetchCategories();

}catch(e){
toast.error("خطای سرور");
}

};




/* ================= حذف ساب آیتم ================= */

const deleteSubItem=async(id)=>{

const ok=window.confirm("این داده حذف شود؟");

if(!ok) return;

try{

const res=await fetch(
apiUrl(`/api/item/${id}`),
{
method:"DELETE",
headers:adminAuthHeaders()
}
);

const data=await res.json();

if(!res.ok){
toast.error(data.error || "خطا در حذف");
return;
}

toast.success("داده حذف شد");

fetchCategories();

}catch(e){
toast.error("خطای سرور");
}

};




const activeCategory=
categories.find(
c=>c.id===selectedCategory
);




return(

<div>

<div className="SelectedHeader">
شما در این قسمت می توانید به دلخواه مظنه جدید ایجاد یا حذف کنید .
</div>



{/* ================= سربرگ ها ================= */}

<p className="mt-3 Bold">
سربرگ ها
</p>


<div className="SarbargNav">

<button
className="AddMazenBtn"
onClick={()=>setShowCategoryModal(true)}
>
ایجاد
</button>


{categories.map(cat=>(

<div
key={cat.id}
onClick={()=>setSelectedCategory(cat.id)}
className={
selectedCategory===cat.id
? "BgYellow ColorBlack Bold mr-3"
: ""
}
style={{
display:"flex",
alignItems:"center",
justifyContent:"space-between",
padding:"10px",
width:"100%",
maxWidth:"200px"
}}
>

<span>
{cat.name}
</span>

<span
onClick={(e)=>{
e.stopPropagation();
deleteCategory(cat.id);
}}
style={{
fontSize:"12px",
opacity:.30,
cursor:"pointer",
transition:"0.2s"
}}
onMouseEnter={(e)=>{
e.target.style.opacity=.8;
}}
onMouseLeave={(e)=>{
e.target.style.opacity=.30;
}}
>
✕
</span>

</div>

))}

</div>





{/* ================= داده های سربرگ ================= */}

<p className="mt-3 Bold">
داده های سربرگ
</p>


<div className="SarbargNav">

<button
className="AddMazenBtn"
onClick={()=>setShowItemModal(true)}
>
ایجاد
</button>


{activeCategory?.items?.map(item=>(

<div
key={item.id}
style={{
display:"flex",
alignItems:"center",
justifyContent:"space-between",
padding:"10px",
width:"100%",
maxWidth:"200px"
}}
>

<span>
{item.title}
</span>

<span
onClick={(e)=>{
e.stopPropagation();
deleteSubItem(item.id);
}}
style={{
fontSize:"12px",
opacity:.30,
cursor:"pointer",
transition:"0.2s"
}}
onMouseEnter={(e)=>{
e.target.style.opacity=.8;
}}
onMouseLeave={(e)=>{
e.target.style.opacity=.30;
}}
>
✕
</span>

</div>

))}

</div>






{/* ================= مودال ایجاد سربرگ ================= */}

{showCategoryModal && (

<div style={{
position:"fixed",
inset:0,
background:"rgba(0,0,0,.5)",
display:"flex",
justifyContent:"center",
alignItems:"center",
zIndex:9999
}}>

<div style={{
background:"#fff",
padding:"20px",
borderRadius:"10px",
width:"320px"
}}>

<h3>
ایجاد سربرگ جدید
</h3>

<input
value={title}
onChange={(e)=>setTitle(e.target.value)}
placeholder="نام سربرگ"
style={{
width:"100%",
padding:"8px",
marginTop:"10px"
}}
/>


<div style={{
marginTop:"15px",
display:"flex",
gap:"10px"
}}>

<button onClick={createCategory}>
ذخیره
</button>

<button
onClick={()=>{
setShowCategoryModal(false);
setTitle("");
}}
>
بستن
</button>

</div>

</div>

</div>

)}







{/* ================= مودال ایجاد داده ================= */}

{showItemModal && (

<div style={{
position:"fixed",
inset:0,
background:"rgba(0,0,0,.5)",
display:"flex",
justifyContent:"center",
alignItems:"center",
zIndex:9999
}}>

<div style={{
background:"#fff",
padding:"20px",
borderRadius:"10px",
width:"320px"
}}>

<h3>
ایجاد داده جدید
</h3>

<input
value={title}
onChange={(e)=>setTitle(e.target.value)}
placeholder="نام داده"
style={{
width:"100%",
padding:"8px",
marginTop:"10px"
}}
/>

<div style={{
marginTop:"15px",
display:"flex",
gap:"10px"
}}>

<button onClick={createSubItem}>
ذخیره
</button>

<button
onClick={()=>{
setShowItemModal(false);
setTitle("");
}}
>
بستن
</button>

</div>

</div>

</div>

)}

</div>

);

}

export default AddMazane;
